import FA from 'react-fontawesome';

// TODO: move this SCSS import into the top level entrypoints to avoid
// the possibility that multiple chunks will include it
import 'font-awesome/scss/font-awesome.scss';

export const FontAwesome = FA;
